import React, { FC, useContext, useEffect, useState } from 'react'

import { RegistrarHeaderInfo } from '../components/RegistrarHeaderInfo/RegistrarHeaderInfo'
import { CustomTabs } from '../components/CustomTabs/CustomTabs'
import { ProfileTab } from '../components/tabs/ProfileTab/ProfileTab'
import { TeamRegistrarTab } from '../components/tabs/TeamRegistrarTab/TeamRegistrarTab'
import { DrawerModal } from '../../common/DrawerModal'
import { QATab } from '../components/tabs/QATab/QATab'
import ActivityTab from '../components/tabs/ActivityTab/ActivityTab'

import { HandleModalContext } from '../../../../layout/mainlayout/MainLayout'

import EventRegisteredUsersService from '../../../../services/firebase-service/event-registered-users/EventRegisteredUsersService'
import EventReviewPublishService from '../../../../services/firebase-service/event-review-publish/EventReviewPublishService'
import RiderTeamMemberService from '../../../../services/firebase-service/rider-team-member/RiderTeamMemberService'
import RecipientsService from '../../../../services/firebase-service/recipients/RecipientsService'
import UserService from '../../../../services/firebase-service/users/userService'
import RegistrationDyDayService from '../../../../services/firebase-service/registration-by-day/RegistrationDyDayService'

import { IRegistrationByDayInterface } from '../../../../models/registrations-by-day/registrationByDay.interface'
import { TEventRegisteredUsers } from '../../../../models/event-registered-users/event-registered-users.interface'
import { IEventReviewPublish } from '../../../../models/event-review-publish/event-review-publish.interface'
import { IUserInterface } from '../../../../models/users/user.interface'
import { IRecipientInterface } from '../../../../models/recipients/recipients.interface'
import { IRiderTeamMemberInterface } from '../../../../models/rider-team-member/riderTeamMember.interface'

import { MODAL_CONSTS } from '../../../../const/modal-const'

interface RegistrarInfoModalProps {
  dataToPassOn: {
    eventId: string
    registrarId: string
    registrationId: string
    defaultOpenedPrimaryAccordion?: string
    defaultOpenedSecondaryAccordion?: 'classes' | 'fees' | 'tickets'
    onClose?: () => Promise<void>
  }
}

export const REGISTRAR_TABS = {
  ACTIVITY: { value: 'activity' },
  PROFILE: { value: 'profile' },
  TEAM: { value: 'team' },
  QA: { value: 'q&a' },
}

export const RegistrarInfoModal: FC<RegistrarInfoModalProps> = ({ dataToPassOn }) => {
  const handleModalContext = useContext(HandleModalContext)

  const {
    eventId,
    registrarId,
    registrationId,
    defaultOpenedPrimaryAccordion,
    defaultOpenedSecondaryAccordion,
    onClose,
  } = dataToPassOn

  const [registrar, setRegistrar] = useState<IUserInterface | null>(null)
  const [recipient, setRecipient] = useState<IRecipientInterface>()
  const [eventRegisteredUser, setEventRegisteredUser] = useState<TEventRegisteredUsers | null>(null)
  const [riders, setRiders] = useState<IRegistrationByDayInterface[]>([])
  const [riderTeamMembers, setRiderTeamMembers] = useState<IRiderTeamMemberInterface[]>([])
  const [activeTab, setActiveTab] = useState(REGISTRAR_TABS.TEAM.value)
  const [loading, setLoading] = useState(true)
  const [eventReviewPublish, setEventReviewPublish] = useState<IEventReviewPublish | null>(null)

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true)

        const registrationDyDayInDb =
          await RegistrationDyDayService.getByRegistrationId(registrationId)

        const eventRegisteredUser_ = await EventRegisteredUsersService.getById(registrationId)
        const publishedEvent = await EventReviewPublishService.getById(eventId)
        const riderTeamMembers_ = await RiderTeamMemberService.getByRegistrationId(registrationId)
        let recipient = await RecipientsService.getByRecipientRegistrationId(
          eventRegisteredUser_.id!,
          registrarId
        )
        const user = await UserService.getUserById(registrarId)

        const uniqueRiders: IRegistrationByDayInterface[] = []
        registrationDyDayInDb.forEach((registeredUserByDay) => {
          const hasRider = uniqueRiders.find(
            (rider) =>
              rider.riderId === registeredUserByDay.riderId &&
              rider.horsesSelected.map(({ id }) => id)?.join('') ===
                registeredUserByDay.horsesSelected.map(({ id }) => id)?.join('')
          )

          if (!hasRider) {
            uniqueRiders.push(registeredUserByDay)
          }
        })

        setRegistrar(user)
        setEventReviewPublish(publishedEvent)
        setRiders(uniqueRiders)
        setRiderTeamMembers(riderTeamMembers_)
        setEventRegisteredUser(eventRegisteredUser_)
        setRecipient(recipient)
      } catch (error) {
        console.error(error, 'error')
      } finally {
        setLoading(false)
      }
    }
    getData().then()
  }, [eventId, registrarId, registrationId])

  return (
    <DrawerModal
      type="REGISTRAR_INFO"
      className="max-h-[calc(100dvh_-46px)] z-[40]"
      overlayClassName="z-[39]"
      onClose={async () => {
        // We need this when the user clicks on "from", "send", "paid" item inside the Classes/Fees/Tickets tabs Rider drawer,
        // Because we need update data inside Rider drawer when user back if user paid inside Registrar drawer
        if (handleModalContext?.activeModalName.includes(MODAL_CONSTS.RIDER_INFO)) {
          handleModalContext?.handleModal?.(false, MODAL_CONSTS.RIDER_INFO)
          setTimeout(() => {
            handleModalContext?.handleModal?.(true, MODAL_CONSTS.RIDER_INFO, {
              ...handleModalContext?.dataToPassOn,
              defaultActiveTab: handleModalContext?.dataToPassOn?.defaultOpenedSecondaryAccordion,
            })
          }, 100)
        }
        if (onClose) await onClose()
      }}
    >
      <div className="w-full text-SeabiscuitDark200ThemeColor max-w-6xl mx-auto px-4 py-10 md:py-20 overflow-auto">
        <RegistrarHeaderInfo
          user={registrar}
          eventId={eventId}
          registrationId={registrationId}
          riders={riders}
          eventRegisteredUser={eventRegisteredUser}
          eventReviewPublish={eventReviewPublish}
          recipient={recipient}
          loading={loading}
          activeTab={activeTab}
        />
        <CustomTabs
          type="registrar"
          color="#5468FF"
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          tabs={REGISTRAR_TABS}
          loading={loading}
        />
        <div className="mt-7">
          {activeTab === REGISTRAR_TABS.PROFILE.value && (
            <ProfileTab
              user={registrar}
              setUser={setRegistrar}
              publishedEvent={eventReviewPublish}
            />
          )}
          {activeTab === REGISTRAR_TABS.ACTIVITY.value && (
            <ActivityTab type="registrar" userId={registrarId} />
          )}
          {activeTab === REGISTRAR_TABS.TEAM.value && (
            <TeamRegistrarTab
              riderTeamMembers={riderTeamMembers}
              eventRequiredUserFields={eventReviewPublish?.EventRequiredFields.requiredFields}
              registrar={registrar}
              eventId={eventId}
              registrationId={registrationId}
              eventReviewPublish={eventReviewPublish}
              defaultOpenedPrimaryAccordion={defaultOpenedPrimaryAccordion}
              defaultOpenedSecondaryAccordion={defaultOpenedSecondaryAccordion}
            />
          )}
          {activeTab === REGISTRAR_TABS.QA.value && (
            <QATab
              eventReviewPublish={eventReviewPublish}
              eventRegisteredUser={eventRegisteredUser}
              setEventRegisteredUser={setEventRegisteredUser}
              riders={riders}
            />
          )}
        </div>
      </div>
    </DrawerModal>
  )
}
